import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    fontSize: 14,
  },

  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: -20,
  },

  radioContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginTop: 20,
  },

  comment: {
    marginTop: 20,
  },

  textArea: {
    borderWidth: 1,
    borderRadius: 5,
    width: '100%',
    minHeight: 200,
    padding: 5,
    resize: 'none',
    backgroundColor: '#F5F5F5',
    marginTop: 20,
  },

  label: {
    fontSize: 14,
    fontWeight: 'bold',
  },

  buttonContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    gap: '1rem',
  },
  leftWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '1rem',
  },

  rightWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '1rem',
  },

  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    color: '#FFFFFF',
    backgroundColor: '#424242',
    width: '12rem',
    transition: 'all 250ms ease-in-out',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
    },
    '&:hover': {
      opacity: '0.8',
    },
  },

  errorText: {
    color: 'red',
    fontWeight: '600',
  },
}))
